<template>
  <div style="display: none;"></div>
</template>

<script>
import freshRelevanceConfig from "@/config/freshRelevance";

export default {
  name: "FreshRelevanceTrackingTag",
  mounted() {
    // Only load Fresh Relevance tracking script if enabled
    if (!freshRelevanceConfig.enabled) {
      return;
    }

    const script = document.createElement("script");
    script.src = freshRelevanceConfig.scriptUrl;
    script.async = true;
    document.head.appendChild(script);
  },
};
</script>
